import React, { useContext } from 'react';
import { Navigate, Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Layout from './Layout';
import { getLandingRoute } from '../config/navigation';

const AccessDenied = ({ permission, fallbackPath }) => (
  <Layout>
    <div className="container">
      <div className="empty-state" style={{ marginTop: 48 }}>
        <span className="empty-state-icon">🔒</span>
        <h2>You don&rsquo;t have access to this page</h2>
        <p>
          This page needs the <strong>{permission}</strong> permission. Ask an administrator
          to update your role if you need it.
        </p>
        {fallbackPath && (
          <Link to={fallbackPath} className="btn btn-primary" style={{ marginTop: 12 }}>
            Go to a page you can access
          </Link>
        )}
      </div>
    </div>
  </Layout>
);

const PrivateRoute = ({ children, permission }) => {
  const { isAuthenticated, loading, hasPermission } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/sy-admin/login" replace />;
  }

  if (permission && !hasPermission(permission)) {
    const fallbackPath = getLandingRoute(hasPermission);

    // The dashboard is the default landing page - quietly send accounts that
    // cannot see it to their own first page instead of showing a denial.
    const isLandingPath =
      location.pathname === '/sy-admin' ||
      location.pathname === '/sy-admin/' ||
      location.pathname === '/sy-admin/dashboard';
    if (isLandingPath && fallbackPath) {
      return <Navigate to={fallbackPath} replace />;
    }

    return <AccessDenied permission={permission} fallbackPath={fallbackPath} />;
  }

  return children;
};

export default PrivateRoute;
